var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-italic mt-2 mt-3 obs-start-hour"},[_vm._v(" Obs.: Será utilizada "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("\""+_vm._s(_vm.formattedStartHour)+"\"")]),_vm._v(" como hora inicial do ciclo diário de irrigação, pois foi definido no cadastro de configurações do manejo. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }